import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import axios from 'axios';
// context
import UserContext from './UserContext';
import config from '../config';
// components
import Navigation from './Navigation';
import RecordPage from './record';
import CalendarPage from './calendar';
import NotFoundPage from './notfound';
import ErrorPage from './error';
// css
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            err: null,
        };
    }

    componentDidMount() {
        this.getUserInfo();
    }

    render() {
        if (this.state.err !== null) {
            return (
                <Router>
                    <Route render={() => <ErrorPage msg={this.state.err.msg} />} />
                </Router>
            )
        } else if (this.state.user === null) {
            return (
                <div>Loading...</div>
            )
        }
        return (
            <UserContext.Provider value={this.state.user}>
                <UserContext.Consumer>
                    {user => (
                        <Router>
                            <div className="App">
                                <Switch>
                                    <Route exact path="/"
                                        render={() => <Navigation userID={user.userID} />} />
                                </Switch>
                                <div className="container">
                                    <Switch>
                                        <Route exact path="/"
                                            render={() => <RecordPage user={user} />} />
                                        <Route path="/calendar"
                                            render={() => <CalendarPage user={user} />} />
                                        <Route component={NotFoundPage} />
                                    </Switch>
                                </div>
                            </div>
                        </Router>
                    )}
                </UserContext.Consumer>
            </UserContext.Provider>
        );
    }
    getUserInfo() {
        let result = {};
        // GetParametarからTokenを取得する
        if (1 < document.location.search.length) {
            // 最初の1文字 (?記号) を除いた文字列を取得する
            const query = document.location.search.substring(1);

            // クエリの区切り記号 (&) で文字列を配列に分割する
            const parameters = query.split('&');

            for (const parameter of parameters) {
                // パラメータ名とパラメータ値に分割する
                const element = parameter.split('=');
                const paramName  = decodeURIComponent(element[0]);
                const paramValue = decodeURIComponent(element[1]);

                // パラメータ名をキーとして連想配列に追加する
                result[paramName] = decodeURIComponent(paramValue);
            }
            console.log('result', result);
        }

        let user = null, err = null;

        if (result.msg) {
            err = {msg: decodeURIComponent(window.atob(result.msg))}
        } else {
            const token = result.token;
            console.log('token', token);
            user = parseJWT(token);
            console.log('user', user);
            if (user === null || user.userID === null || !/^[06G]\d{5}$/.test(user.userID)) {
                // tokenがない or userIDがデフォルト値(null) の場合
                // userIDが 0 または 6 から始まる6桁の数字でない場合
                err = {msg: '認証の有効期限が切れました。再認証してください。'}
            } else {
                // 正常な場合
                user.token = token;
            }
        }

        this.setState({ user, err });
    }
    // 以下Oldソース
    // getUserInfo = async () => {
    //   const url = `${config.endpoint}/user`;
    //   const options = {
    //     headers: { 'x-api-key': config.apikey }
    //   };
    //   return await axios.get(url, options)
    //     .then(response => {
    //       const token = response.data.token;
    //       const user = parseJWT(token);
    //
    //       if (!/^[06]\d{5}$/.test(user.userID)) {
    //           throw new Error(`アクセスできません（${user.userID}）`);
    //       }
    //
    //       user.token = token;
    //
    //       this.setState({ user });
    //     }).catch(error => {
    //       console.error('error', error);
    //       if (error.message.indexOf('アクセスできません')) alert(error.message);
    //     });
    // }
}

const parseJWT = (token) => {
    if (!token) return null;
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js